import { render, staticRenderFns } from "./MailBody.vue?vue&type=template&id=4781105d&"
import script from "./MailBody.vue?vue&type=script&lang=js&"
export * from "./MailBody.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib'
import { VDialog } from 'vuetify/lib'
import { VToolbar } from 'vuetify/lib'
installComponents(component, {
  VBtn,
  VDialog,
  VToolbar,
})
